function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import Card from "./Card";
import CardBody from "./CardBody";
var defaultProps = {
  label: '--',
  reverse: true,
  value: '--'
};

var SummaryBoxItem = function SummaryBoxItem(_ref) {
  var className = _ref.className,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? defaultProps.label : _ref$label,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? defaultProps.reverse : _ref$reverse,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? defaultProps.value : _ref$value,
      props = _objectWithoutProperties(_ref, ["className", "label", "reverse", "value"]);

  var bodyClassNames = classnames('text-center d-flex justify-content-end', {
    'flex-column-reverse': reverse,
    'flex-column': !reverse
  });
  var valueClassNames = classnames('h3', {
    'mb-1 mt-0': reverse,
    'mb-0 mt-1': !reverse
  });
  return /*#__PURE__*/React.createElement(Card, _extends({
    outline: true,
    className: classnames('rounded-0 shadow-none', className)
  }, props), /*#__PURE__*/React.createElement(CardBody, {
    className: bodyClassNames
  }, /*#__PURE__*/React.createElement("small", {
    className: "text-muted text-uppercase"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: valueClassNames
  }, value)));
};

SummaryBoxItem.displayName = "SummaryBoxItem";
SummaryBoxItem.displayName = 'SummaryBoxItem';
SummaryBoxItem.defaultProps = defaultProps;
export default SummaryBoxItem;